import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const InfoIconMedium: React.FC<IconProps> = (props) => (
  <IconWrapper {...props}>
    <path d="M10.94 6.56c0-.58.48-1.08 1.06-1.08.58 0 1.06.5 1.06 1.08 0 .58-.5 1.06-1.06 1.06s-1.06-.5-1.06-1.06Zm.25 11.95V9.29h1.6v9.22h-1.6Z M19.07 3C20.13 3 21 3.86 21 4.93v14.15c0 1.06-.86 1.93-1.93 1.93H4.93c-1.06 0-1.93-.86-1.93-1.93V4.93C3 3.87 3.86 3 4.93 3h14.15m0-1H4.93C3.32 2 2 3.31 2 4.93v14.15c0 1.61 1.31 2.93 2.93 2.93h14.14c1.61 0 2.93-1.31 2.93-2.93V4.93C22 3.32 20.69 2 19.07 2h.01Z" />
  </IconWrapper>
)

export default InfoIconMedium
